// extracted by mini-css-extract-plugin
export default {"confirmButton":"confirmButton-_udMv"};